export default __webpack_public_path__ + "static/media/video.0f0cacfa.svg";